import { render, staticRenderFns } from "./BehaviorDetail.vue?vue&type=template&id=422161d6&scoped=true"
var script = {}
import style0 from "./BehaviorDetail.vue?vue&type=style&index=0&id=422161d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422161d6",
  null
  
)

export default component.exports